<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <nav aria-label="breadcrumb">
           <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/">Início</router-link></li>
                <li class="breadcrumb-item active" aria-current="page">Meus dados / {{ client.name }}</li>
            </ol>
        </nav>
        <div class="row" v-if="enable_error_list">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="alert alert-danger">
                    <ol>
                        <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                    </ol>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="tab-content">
                    <div class="tab-pane active" role="tabpanel" id="info">
                        <div class="card shadow mb-4">
                            <!-- Card Header - Dropdown -->
                            <div class="card-body">
                                <fieldset>
                                    <legend>Dados gerais</legend>
                                    <div class="row mt-2">
                                        <div class="col-xl-2 col-md-2 col-sm-12">
                                            <label for="">Matrícula</label>
                                            <div class="input-group mb-3">
                                                <input type="text" v-if="client.mat != ''" class="form-control"
                                                    v-model="client.mat" disabled>
                                                <input type="text" v-else class="form-control" value="Não informada"
                                                    disabled>
                                            </div>
                                        </div>
                                        <div class="col-xl-4 col-md-4 col-sm-12">
                                            <label for="">CPF</label>
                                            <div class="input-group mb-3">
                                                <input type="text" class="form-control" v-model="client.document"
                                                    disabled>
                                            </div>
                                        </div>
                                        <div class="col-xl-6 col-md-6 col-sm-12">
                                            <label for="">Nome</label>
                                            <input type="text" class="form-control" placeholder="Ex: Empresa XYZ"
                                                v-model="client.name" disabled>
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col-xl-4 col-md-4 col-sm-12">
                                            <label for="">Data de nascimento</label>
                                            <input type="date" v-if="client.birthday != ''" class="form-control"
                                                v-model="client.birthday" disabled>
                                            <input type="text" v-else class="form-control" value="Não informado"
                                                disabled>
                                        </div>
                                        <div class="col-xl-4 col-md-4 col-sm-12">
                                            <label for="">Sexo</label>
                                            <select class="form-control" disabled>
                                                <option>{{ client.gender ? getGender(client.gender) : 'Não informado' }}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="col-xl-4 col-md-4 col-sm-12">
                                            <label for="">Telefone</label>
                                            <input type="text" v-if="client.phone != ''" class="form-control"
                                                v-model="client.phone" disabled>
                                            <input type="text" v-else class="form-control" value="Não informado"
                                                disabled>
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col-xl-12 col-md-12 col-sm-12">
                                            <label for="">E-mail</label>
                                            <input type="text" v-if="client.email != ''" class="form-control"
                                                v-model="client.email" disabled>
                                            <input type="text" v-else class="form-control" value="Não informado"
                                                disabled>
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col-xl-4 col-md-4 col-sm-12">
                                            <label for="">RG</label>
                                            <input type="text" v-if="client.rg != ''" class="form-control"
                                                v-model="client.rg" disabled>
                                            <input type="text" v-else class="form-control" value="Não informado"
                                                disabled>
                                        </div>
                                        <div class="col-xl-3 col-md-4 col-sm-12">
                                            <label for="">Órgão expeditor</label>
                                            <select class="form-control" disabled>
                                                <option>{{ client.issuing_body ? client.issuing_body : 'Não informado'
                                                    }}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="col-xl-3 col-md-4 col-sm-12">
                                            <label for="">UF Órgão expeditor</label>
                                            <select class="form-control" disabled>
                                                <option>{{ client.uf_issuing_body ? client.uf_issuing_body : 'Não informado'}}</option>
                                            </select>
                                        </div>
                                        <div class="col-xl-2 col-md-2 col-sm-12">
                                            <label for="">Data Expedição</label>
                                            <input type="date" v-if="client.date_dispatch != ''" class="form-control"
                                                v-model="client.date_dispatch" disabled>
                                            <input type="text" v-else class="form-control" value="Não informado"
                                                disabled>
                                        </div>
                                    </div>
                                    <div class="row mt-2 mb-4">
                                        <div class="col-xl-6 col-md-6 col-sm-12">
                                            <label for="">Nome do pai</label>
                                            <input type="text" v-if="client.name_father != ''" class="form-control"
                                                v-model="client.name_father" disabled>
                                            <input type="text" v-else class="form-control" value="Não informado"
                                                disabled>
                                        </div>
                                        <div class="col-xl-6 col-md-6 col-sm-12">
                                            <label for="">Nome da mãe</label>
                                            <input type="text" v-if="client.name_mother != ''" class="form-control"
                                                v-model="client.name_mother" disabled>
                                            <input type="text" v-else class="form-control" value="Não informado"
                                                disabled>
                                        </div>
                                    </div>
                                    <div class="row mt-2 mb-4">
                                        <div class="col-xl-3 col-md-3 col-sm-12">
                                            <label for="">Nº título e eleitor</label>
                                            <input type="text" v-if="client.number_registration_voter != ''"
                                                class="form-control" v-model="client.number_registration_voter"
                                                disabled>
                                            <input type="text" v-else class="form-control" value="Não informado"
                                                disabled>
                                        </div>
                                        <div class="col-xl-3 col-md-3 col-sm-12">
                                            <label for="">Estado Civil</label>
                                            <select class="form-control" disabled>
                                                <option>{{ client.status_civil ? client.status_civil : 'Não informado'
                                                    }}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="col-xl-3 col-md-3 col-sm-12">
                                            <label for="">PIS/PASEP</label>
                                            <input type="text" v-if="client.pis_pasep != ''" class="form-control"
                                                v-model="client.pis_pasep" disabled>
                                            <input type="text" v-else class="form-control" value="Não informado"
                                                disabled>
                                        </div>
                                        <div class="col-xl-3 col-md-3 col-sm-12">
                                            <label for="">Etnia</label>
                                            <select class="form-control" disabled>
                                                <option>{{ client.ethnicity ? client.ethnicity : 'Não informado' }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row mt-2 mb-4">
                                        <div class="col-xl-6 col-md-6 col-sm-12">
                                            <label for="">Escolaridade</label>
                                            <label for="">Etnia</label>
                                            <select class="form-control" disabled>
                                                <option>{{ client.education ? client.education : 'Não informado' }}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="col-xl-6 col-md-6 col-sm-12">
                                            <label for="">Profissão</label>
                                            <input type="text" v-if="client.occupation != ''" class="form-control"
                                                v-model="client.occupation" disabled>
                                            <input type="text" v-else class="form-control" value="Não informado"
                                                disabled>
                                        </div>
                                    </div>
                                </fieldset>
                                <br>
                                <fieldset>
                                    <legend>Endereço</legend>
                                    <div class="row mt-2">
                                        <div class="col-xl-3 col-md-3 col-sm-12">
                                            <label for="">CEP</label>

                                            <div class="input-group mb-3">
                                                <input type="text" v-if="client.zipcode != ''" class="form-control"
                                                    v-model="client.zipcode" disabled>
                                                <input type="text" v-else class="form-control" value="Não informado"
                                                    disabled>
                                            </div>
                                        </div>
                                        <div class="col-xl-7 col-md-7 col-sm-12">
                                            <label for="">Endereço</label>
                                            <input type="text" v-if="client.street != ''" class="form-control"
                                                v-model="client.street" disabled>
                                            <input type="text" v-else class="form-control" value="Não informado"
                                                disabled>
                                        </div>
                                        <div class="col-xl-2 col-md-2 col-sm-12">
                                            <label for="">Nº</label>
                                            <input type="text" v-if="client.number_street != ''" class="form-control"
                                                v-model="client.number_street" disabled>
                                            <input type="text" v-else class="form-control" value="Não informado"
                                                disabled>
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col-xl-12 col-md-12 col-sm-12">
                                            <label for="">Complemento</label>
                                            <input type="text" v-if="client.complement != ''" class="form-control"
                                                v-model="client.complement" disabled>
                                            <input type="text" v-else class="form-control" value="Não informado"
                                                disabled>
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col-xl-4 col-md-4 col-sm-12">
                                            <label for="">Bairro</label>
                                            <input type="text" v-if="client.district != ''" class="form-control"
                                                v-model="client.district" disabled>
                                            <input type="text" v-else class="form-control" value="Não informado"
                                                disabled>
                                        </div>
                                        <div class="col-xl-4 col-md-4 col-sm-12">
                                            <label for="">Cidade</label>
                                            <input type="text" v-if="client.city != ''" class="form-control"
                                                v-model="client.city" disabled>
                                            <input type="text" v-else class="form-control" value="Não informado"
                                                disabled>
                                        </div>
                                        <div class="col-xl-4 col-md-4 col-sm-12">
                                            <label for="">UF</label>
                                            <input type="text" v-if="client.uf != ''" class="form-control"
                                                v-model="client.uf" disabled>
                                            <input type="text" v-else class="form-control" value="Não informado"
                                                disabled>
                                        </div>
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import { mask } from 'vue-the-mask'

export default {
    directives: { mask },
    components: { Loading },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            gender_options: [
                { type: 'm', value: 'Masculino' },
                { type: 'f', value: 'Feminino' },
                { type: 'o', value: 'Outros' },
            ],
            issuing_body_options: ['SSP', 'Cartório Civil', 'Polícia Federal', 'DETRAN'],
            uf_issuing_body_options: ['AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO', 'EX (Estrangeiro)'],
            status_civil_options: ['Casado (a) (Comunhão parcial)', 'Casado (a) (Comunhão total)', 'Separado (a)', 'Divorciado (a)', 'Desquitado (a)', 'Viúvo (a)', 'Casado (a) (Separação total de bens)', 'Solteiro (a)'],
            ethnicity_options: ['Branca', 'Preta', 'Parda', 'Amarela', 'Indígena'],
            education_options: ['Ensino Médio Incompleto', 'Ensino Médio Completo', 'Gradução Incompleta', 'Graduação Completa', 'Pós Graduação Completa', 'Pós Graduação Incompleta'],
            gender_multiselect: '',
            client: {
                mat: '',
                document: '',
                name: '',
                birthday: '',
                gender: '',
                phone: '',
                email: '',
                rg: '',
                issuing_body: '',
                uf_issuing_body: '',
                date_dispatch: '',
                name_father: '',
                name_mother: '',
                number_registration_voter: '',
                status_civil: '',
                pis_pasep: '',
                ethnicity: '',
                education: '',
                occupation: '',
                zipcode: '',
                street: '',
                number_street: '',
                complement: '',
                district: '',
                city: '',
                uf: '',
                observation: ''
            },
            enable_error_list: false,
            errors: []
        }
    },

    computed: {
        isDisabled: function () {
            return this.client.document != '' && this.client.name != '' && this.client.phone != '';
        }
    },
    mounted() {
        this.isLoading = false;
        this.getclient();

    },
    beforeMount() {
        const id =  localStorage.getItem('client_id');
        this.client.id = id;
    },
    methods: {
        onCancel() { },
        getGender(gender) {
            if (gender == 'f') {
                return 'Feminino';
            } else if (gender == 'm') {
                return 'Masculino';
            } else {
                return 'Outros';
            }
        },
        async getclient() {
            const response = await api.get('/client-user/' + this.client.id)
                .then((response) => {
                    this.isLoading = false;
                    this.client = response.data.client;
                    this.client.document = response.data.client.document_formatted;
                    this.client.phone = response.data.client.phone_formatted;
                    this.$refs.myChild.updateTextEditor(this.client.observation);

                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status, error);
                });
            return response;

        },


    }
}
</script>

<style lang="scss" scoped></style>